export const PLR2 = {
    "uuid": "1aa4b179-9990-4e29-a531-049748dd94c8",
    "createdAt": "2022-07-24T12:02:05Z",
    "updatedAt": "2023-08-24T14:15:22Z",
    "roadwork": "095be615-a8ad-4c33-8e9c-c7612fbf6c9f",
    "taskType": "PLR2",
    "cost": "931.09",
    "quantity": "23.02",
    "unit": "t",
    "comment": "blabla",
}

export const PLS1 = {
    "uuid": "095be615-a8ad-4c33-8e9c-c7612fbf6c9f",
    "createdAt": "2022-07-24T12:02:05Z",
    "updatedAt": "2023-08-24T14:15:22Z",
    "roadwork": "095be615-a8ad-4c33-8e9c-c7612fbf6c9f",
    "taskType": "PLS1",
    "cost": "121.99",
    "quantity": "13.26",
    "unit": "m3",
    "comment": "blabla",
}

export const PLR1 = {
    "uuid": "8a2f3d4c-66e3-4ccc-831f-acaf715bcf53",
    "createdAt": "2022-07-24T12:02:05Z",
    "updatedAt": "2023-08-24T14:15:22Z",
    "roadwork": "af83ebfc-0c51-4a51-9992-b8cea9612bb6",
    "taskType": "PLR1",
    "cost": "222",
    "quantity": "26",
    "unit": "m3",
    "comment": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ut lacinia diam, eget luctus sapien. Donec quis porta erat. Quisque aliquam lorem ac vulputate malesuada. Duis convallis justo at elementum mattis. Maecenas quis eros vel leo suscipit cursus vel sed massa. Ut diam erat, semper eu ex sed, ultricies sollicitudin ligula. Fusce pretium elementum ornare.Etiam quis molestie quam. Quisque ut quam nisl. Mauris vehicula, eros sed suscipit placerat, neque eros vestibulum lorem, eget ultrices nunc ipsum a diam. Vestibulum finibus ac lorem convallis mattis. Nullam eget ultrices felis. Sed id ultrices felis. Praesent pulvinar sed elit elementum vehicula.Aliquam sagittis dolor non arcu bibendum iaculis. Aenean molestie velit aliquam rutrum cursus. Duis interdum sem quis leo imperdiet commodo. Curabitur purus velit, dapibus eget quam in, venenatis aliquam arcu. Praesent mollis ac lectus placerat vehicula. Nunc nec ex lobortis, bibendum urna ut, elementum odio. Maecenas lobortis, ligula pretium commodo ultrices, ligula tellus euismod erat, ut bibendum risus nisl non magna. Vivamus lorem mi, vestibulum ut risus quis, consequat feugiat est. Duis maximus diam a arcu tempus fringilla. Nunc id nisl malesuada, fringilla eros id, elementum risus.    Curabitur magna risus, porta non mi vel, laoreet commodo lacus. Maecenas sed dolor vel neque vulputate finibus. Phasellus nec mattis ex. Fusce vel libero non metus maximus blandit in congue tellus. Praesent suscipit auctor ante, eu lacinia dui feugiat sed. Pellentesque mollis velit felis, at consectetur tortor dignissim vitae. Aliquam erat volutpat. Cras dui elit, sodales at diam id, condimentum tempor lorem. Praesent ut tincidunt dolor. Nam id turpis augue.ivamus elit velit, consectetur in eros sed, eleifend euismod dui. Morbi condimentum libero magna, sed porttitor nibh fringilla in. Sed eget justo a nulla vehicula consectetur. Duis commodo scelerisque leo ac tristique. Nunc auctor auctor mi, aliquam molestie leo dignissim non. Sed id lacus egestas dui elementum sodales. Vestibulum eu mattis orci, ac ornare elit.",
}

export const PONTA = {
    "uuid": "b5254c13-03e1-486e-ac1a-8ba7098feaa9",
    "createdAt": "2022-07-24T12:02:05Z",
    "updatedAt": "2023-08-24T14:15:22Z",
    "roadwork": "af83ebfc-0c51-4a51-9992-b8cea9612bb6",
    "taskType": "PONTA",
    "cost": "333",
    "quantity": "11",
    "unit": "m3",
    "comment": "blabla",
}

export const FRAIS = {
    "uuid": "8b8ece98-9c9a-4626-8c5f-81d0f8b112f7",
    "createdAt": "2022-07-24T12:02:05Z",
    "updatedAt": "2023-08-24T14:15:22Z",
    "roadwork": "af83ebfc-0c51-4a51-9992-b8cea9612bb6",
    "taskType": "FRAIS",
    "cost": "3783",
    "quantity": "151",
    "unit": "m3",
    "comment": "",
}


export const tasks = {
    [PLR2.uuid]: PLR2,
    [PLS1.uuid]: PLS1,
    [PLR1.uuid]: PLR1,
    [PONTA.uuid]: PONTA,
    [FRAIS.uuid]: FRAIS,
}
